import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconProvider from '../../../../components/icons/IconProvider';
import { VehicleContext, IVehicleContext } from '../../../../context/VehicleProvider';
import { useVehicleByIdQuery } from '../../../../hooks/useVehiclesQuery';
import "./VehicleInfos.css";

function VehicleInfos() {
    const { t } = useTranslation();
    const { vehicle, capacityFull, powerMaxStandard, powerMaxFast, basicConnectors, optionalConnectors } = useContext(VehicleContext) as IVehicleContext
    const vehicleDetails = useVehicleByIdQuery(vehicle?.Id, true)
    const vehicleInfos = vehicleDetails.data.data!
    const [accordionOpen, setAccordionOpen] = useState<boolean>(false)

    if (!vehicleDetails.isSuccess) {
        return (
            <>
                <Card>
                    <CardHeader
                        avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
                        title={<Skeleton animation="wave" height={15} style={{ marginBottom: 4 }} />}
                        subheader={<Skeleton animation="wave" height={10} width="50%" />}
                    />
                </Card>
            </>
        )
    }

    return (
        <>
            {(vehicleInfos) &&
                <div className='vehicle-infos-accordion'>
                    <ClickAwayListener onClickAway={() => setAccordionOpen(false)}>
                        <Accordion className="accordion" expanded={accordionOpen} onChange={() => setAccordionOpen((prevOpen) => !prevOpen)} disableGutters square>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon color="primary" />}
                                className="info-card"
                            >
                                <IconProvider id="car" color="red-filter" size="medium" />
                                <div className='vehicle-infos-summary-text'>
                                    <Typography variant="h5" color="secondary" textAlign={'left'}>
                                        {vehicleInfos.Brand + " " + vehicleInfos.Model}
                                    </Typography>
                                    {vehicleInfos.Version && <span>{vehicleInfos.Version}</span>}
                                </div>
                            </AccordionSummary>
                            <AccordionDetails className='accordion-details'>
                                {(typeof capacityFull !== 'undefined') && <div className='vehicle-infos-summary-text'>
                                    <span className='grey-text'>{t("vehicle-profile.battery-capacity-option")} :</span>
                                    <span>{capacityFull[0]} kWh ({capacityFull[1]} km)</span>
                                </div>}
                                {(typeof (powerMaxFast) !== 'undefined') && <div className='vehicle-infos-summary-text'>
                                    <span className='grey-text'>{t("vehicle-profile.fast-charge-option")} :</span>
                                    <span>{(powerMaxFast === 0 ? t("vehicle-profile.no-fast-charge-option") : powerMaxFast + ' kW')}</span>
                                </div>}
                                {(powerMaxStandard) && <div className='vehicle-infos-summary-text'>
                                    <span className='grey-text'>{t("vehicle-profile.standard-charge-option")} :</span>
                                    <span>{powerMaxStandard} kW</span>
                                </div>}
                                <div className='vehicle-infos-summary-text'>
                                    <span className='grey-text'>{t("vehicle-infos.details")}</span>
                                </div>
                                <div className="vehicle-profile-icon-container">
                                    <div className="list-icons">
                                        <IconProvider id={basicConnectors?.standardPlug} color="grey-filter" size="large" />
                                        <span className='connector-standard'>{t("connector." + basicConnectors?.standardPlug)}</span>
                                    </div>
                                    {(basicConnectors?.fastPlugObject !== undefined && basicConnectors.fastPlugObject.fastPlugOptional === false && basicConnectors.fastPlugObject.fastPlug !== "IEC_62196_T2") ?
                                        <div className="list-icons">
                                            <IconProvider id={basicConnectors?.fastPlugObject.fastPlug} color="grey-filter" size="large" />
                                            <span className='connector-standard'>{t("connector." + basicConnectors?.fastPlugObject.fastPlug)}</span>
                                        </div> : ""
                                    }
                                    {optionalConnectors.map((item: any, key: any) => (
                                        <div key={key} className="list-icons">
                                            <IconProvider id={item} color="grey-filter" size="large" />
                                            <span className='connector-standard'>{t("connector." + item)}</span>
                                        </div>
                                    ))}
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </ClickAwayListener>
                </div>
            }
        </>
    )
}

export default VehicleInfos;